import QRCode from 'react-qr-code'
import { darken } from '@mui/system'

type Props = {
  url: string
}

export const QRCodeWithLogo = ({ url }: Props) => {
  const qrSize = 200
  const backgroundSize = qrSize / 4
  const logoSize = backgroundSize * 0.8

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <svg width={qrSize} height={qrSize}>
        <QRCode value={url} size={qrSize} style={{ width: '100%', height: '100%' }} fgColor={darken('#e52149', 0.5)} />
        <circle cx={qrSize / 2} cy={qrSize / 2} r={backgroundSize / 2} fill="white" />
        <image
          x={(qrSize - logoSize) / 2}
          y={(qrSize - logoSize) / 2 - 2}
          width={logoSize}
          height={logoSize}
          href="/favicon64x64.png"
        />
      </svg>
    </div>
  )
}
